import {useQuery} from "@tanstack/react-query";
import {REPORT_ENDPOINTS} from "../../services/network/endpoints";
import {ReportAPI} from "../../services/network/report-api";

export function useFetchReportsChartData(owner: string, section: string, param: string) {

    const {data, error, isLoading} = useQuery({
        queryKey: [REPORT_ENDPOINTS.FETCH_CHART_DATA, owner, section, param],
        queryFn: () => ReportAPI.fetchChartData(owner, section, param),
        enabled: Boolean(owner && section && param)
    });

    return {
        reportsChartData: data?.data,
        reportsChartError: error,
        reportsChartIsLoading: isLoading,
    };
}